export default __webpack_public_path__ + "static/media/bg.6ac508b8.webp";